<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'staffPropertyGroup'" pageName="addstaffPropertyGroup" :headers="headers"
      :paginationOptions="options" @turnPage="getlist" :isLoading="loading" :slotKey="['staff_property_group_name']"
      :hideAddBtn="!hasBtn('add-staff-property-group')" :items="desserts">

      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.staff_property_group_name="{ item }">
        <span>{{ INT(item.staff_property_group_name) }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-staff-property-group',
              'edit-staff-property-group',
              'delete-staff-property-group',
            ]">
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import {
  getStaffPropertyGroup,
  deleteStaffPropertyGroup,
} from "@/service/api/staffPropertyGroup.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
    }
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {

    await this.getBtnPermissionList()
  },
  async mounted() {
    await this.getlist()
  },
  beforeDestroy() { },
  methods: {
    goadd() {
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_subPage_name", "")
      this.$router.push({
        name: "addstaffPropertyGroup",
      })
    },
    rowgodetail(item) {
      this.$store.commit("set_iconstatus", true)
      this.$store.commit("set_uuid", item.uuid)
      this.$store.commit("set_subPage_name", item.staff_property_group_name)
      this.$router.push({
        name: "detailstaffPropertyGroup",
        params: {
          uuid: item.uuid,
        },
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true)
      this.$store.commit("set_uuid", item.uuid)
      this.$store.commit("set_subPage_name", item.staff_property_group_name)
      this.$router.push({
        name: "detailstaffPropertyGroup",
        params: {
          uuid: item.uuid,
        },
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$store.commit("set_subPage_name", obj.staff_property_group_name)
          this.$router.push({
            name: "detailstaffPropertyGroup",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteStaffPropertyGroup({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    async getlist(obj) {
      //获取列表
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getStaffPropertyGroup({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_staff_property_group_name"),
          align: "start",
          sortable: false,
          value: "staff_property_group_name",
          width: "600",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-property-group"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-property-group"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-staff-property-group"),
          type: "del",
        },
      ]
    },
  },
  watch: {
    $route(v) {
      if (v.name == "staffPropertyGroup") {
        this.getlist()
      }
    },
  },
}
</script>

<style scoped></style>
